import React, { useEffect, useState, useCallback } from "react";
import Tree from "react-d3-tree";
import { Modal, Button } from "react-bootstrap";

export default function ReferralTree({ data }) {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight - 150,
  });
  const [selectedUser, setSelectedUser] = useState(null);

  // Responsive tree container
  const updateSize = useCallback(() => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight - 150,
    });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, [updateSize]);

  if (!data) return <p className="text-center mt-5">Loading tree...</p>;

  // 🎨 Custom Node Renderer
  const renderCustomNode = ({ nodeDatum, toggleNode }) => (
    <g>
      {/* Circle - click to expand/collapse */}
      <circle
        r={18}
        onClick={(e) => {
          e.stopPropagation(); // ❌ prevent auto-zoom
          toggleNode(); // ✅ only expand/collapse
        }}
        // onClick={toggleNode}
        fill={
          nodeDatum.role === "admin"
            ? "#0d6efd"
            : nodeDatum.role === "distributor"
            ? "#198754"
            : "#ffc107"
        }
        stroke="#333"
        strokeWidth={2}
        style={{ cursor: "pointer", transition: "all 0.3s ease" }}
      >
        <title>
          {nodeDatum.email}
          {"\n"}Referral: {nodeDatum.referral_code}
        </title>
      </circle>

      {/* Name - styled with foreignObject */}
      <foreignObject x={25} y={-15} width={200} height={40}>
        <div
          style={{
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: "Arial, sans-serif",
            color: "#212529",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
          onClick={() => setSelectedUser(nodeDatum)}
        >
          {nodeDatum.name}
        </div>
      </foreignObject>
    </g>
  );

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "80vh",
          border: "1px solid #e0e0e0",
          borderRadius: "10px",
          backgroundColor: "#f8f9fa",
          overflow: "hidden",
        }}
      >
        <Tree
          data={data}
          renderCustomNodeElement={renderCustomNode}
          orientation="vertical"
          translate={{ x: dimensions.width / 2, y: 60 }}
          zoomable={true}
          scaleExtent={{ min: 0.5, max: 2 }}
          separation={{ siblings: 1.5, nonSiblings: 2 }}
          pathFunc="step"
          transitionDuration={800} // 🔹 smooth expand/collapse
        />
      </div>

      {/* Bootstrap Modal for User Info */}
      <Modal
        show={!!selectedUser}
        onHide={() => setSelectedUser(null)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedUser && (
            <div>
              <p>
                <strong>Name:</strong> {selectedUser.name}
              </p>
              <p>
                <strong>Email:</strong> {selectedUser.email}
              </p>
              <p>
                <strong>Role:</strong> {selectedUser.role}
              </p>
              <p>
                <strong>Referral Code:</strong> {selectedUser.referral_code}
              </p>
              {selectedUser.city && (
                <p>
                  <strong>City:</strong> {selectedUser.city}
                </p>
              )}
              {selectedUser.country && (
                <p>
                  <strong>Country:</strong> {selectedUser.country}
                </p>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setSelectedUser(null)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

// import React, { useEffect, useState, useCallback } from "react";
// import Tree from "react-d3-tree";

// // Custom node renderer
// const renderNode = ({ nodeDatum, toggleNode }) => (
//   <g>
//     <circle
//       r={20}
//       onClick={toggleNode}
//       fill={
//         nodeDatum.role === "admin"
//           ? "#0d6efd" // Bootstrap primary (blue)
//           : nodeDatum.role === "distributor"
//           ? "#198754" // green
//           : "#ffc107" // yellow
//       }
//       stroke="#333"
//       strokeWidth={2}
//       style={{ cursor: "pointer" }}
//     >
//       <title>
//         {nodeDatum.email}
//         {"\n"}Referral: {nodeDatum.referral_code}
//       </title>
//     </circle>

//     <text
//       fill="#000"
//       x={30}
//       dy=".35em"
//       fontSize="14px"
//       fontWeight="500"
//     >
//       {nodeDatum.name}
//     </text>
//   </g>
// );

// export default function ReferralTree({ data }) {
//   const [dimensions, setDimensions] = useState({
//     width: window.innerWidth,
//     height: window.innerHeight - 150,
//   });

//   // handle resize
//   const updateSize = useCallback(() => {
//     setDimensions({
//       width: window.innerWidth,
//       height: window.innerHeight - 150,
//     });
//   }, []);

//   useEffect(() => {
//     window.addEventListener("resize", updateSize);
//     return () => window.removeEventListener("resize", updateSize);
//   }, [updateSize]);

//   if (!data) return <p className="text-center mt-5">Loading tree...</p>;

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "80vh",
//         border: "1px solid #e0e0e0",
//         borderRadius: "10px",
//         backgroundColor: "#f8f9fa",
//         overflow: "hidden",
//       }}
//     >
//       <Tree
//         data={data}
//         renderCustomNodeElement={renderNode}
//         orientation="vertical"
//         translate={{ x: dimensions.width / 2, y: 60 }}
//         zoomable={true}
//         scaleExtent={{ min: 0.5, max: 2 }}
//         separation={{ siblings: 1.5, nonSiblings: 2 }}
//         pathFunc="step"
//         transitionDuration={500}
//       />
//     </div>
//   );
// }
